module.exports = __webpack_public_path__ + "static/media/goodnest_app9.d00081af.jpg";